/**
 * Standalone duty & tax estimator: the form, then the estimate as ranges.
 * Mounted on the company page and the moderator page.
 */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getApiErrorMessage } from "../../lib/apiError";
import type { EstimateResponse } from "../../services/tradecosts/generated/model";
import { useTradeCostsEstimateCreate } from "../../services/tradecosts/generated/trade-costs/trade-costs";
import TradeEstimateForm, { EMPTY_ESTIMATE_VALUES, toEstimateRequest } from "./TradeEstimateForm";
import TradeEstimateResult from "./TradeEstimateResult";
import "./TradeEstimate.css";

const TradeEstimateTool = ({ initialHsCode = "" }: { initialHsCode?: string }) => {
  const { t } = useTranslation("trade");
  const [estimate, setEstimate] = useState<EstimateResponse | null>(null);
  const create = useTradeCostsEstimateCreate({ mutation: { onSuccess: setEstimate } });

  return (
    <div className="te">
      <section className="te-card">
        <h2 className="te-card__title">{t("tool.formTitle")}</h2>
        <p className="te-help">{t("tool.formHelp")}</p>
        <TradeEstimateForm
          initial={{ ...EMPTY_ESTIMATE_VALUES, hsCode: initialHsCode }}
          submitLabel={t("tool.submit")}
          busy={create.isPending}
          onSubmit={(values) => create.mutate({ data: toEstimateRequest(values) })}
        />
        {create.isError ? <p className="te-error">{getApiErrorMessage(create.error, t("tool.error"))}</p> : null}
      </section>
      {estimate ? <TradeEstimateResult estimate={estimate} /> : null}
    </div>
  );
};

export default TradeEstimateTool;
